import { render, staticRenderFns } from "./SupportCard.vue?vue&type=template&id=d3dfcb90"
import script from "./SupportCard.vue?vue&type=script&lang=ts"
export * from "./SupportCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports